
import { FilteredEvent } from "@/store/eventqueue/types";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class RestoreIcon extends Vue {
	@Prop({ default: null}) readonly currentEvent!: FilteredEvent;

	public get restoreCount(): number {
		if (!this.currentEvent || !this.currentEvent.awaitingRestoreCount) {
			return 0;
		}
		return this.currentEvent.awaitingRestoreCount;
	}
}
